import type { IContributionProjetRepository } from '../../domain/ports/IContributionProjetRepository';
import type { ContributionProjetDTO } from '../dto/dtos';

export interface ListerParProjetInput  { idProjet: string; }
export interface ListerParProjetOutput { contributions: ContributionProjetDTO[]; }

export class ListerContributionsParProjetUseCase {
  constructor(private readonly repository: IContributionProjetRepository) {}

  async execute(input: ListerParProjetInput): Promise<ListerParProjetOutput> {
    const response = await this.repository.listerParProjet(input.idProjet);
    if (!response.succes) throw new Error(response.message || 'Erreur lors de la récupération');
    return { contributions: response.data ?? [] };
  }
}
